import { join } from 'lodash'
import moment from 'moment'
import sim from '@/api/sale/sim-distribute'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  formViewData: [],
  branch_id: [],
  location_id: [],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewData = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewData[el] = data[el];
      });
    }
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          date_between: join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return sim.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  async getFormViewData(context, { params, index }) {
    let response = await sim.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
}
